<template>
  <div>
    <Dashboard />
    <section id="content">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-3 pdd-left2">
                <NextPercentAmount />
                <div class="box-2" v-if="this.bonus">
                  <div class="box-title01">
                    <p>
                      Бонус шилжүүлэх
                      <img src="@/assets/icon/help.png" @click="showHelpDlg" />
                    </p>
                  </div>

                  <div class="row" v-if="this.accounts.length > 1">
                    <div class="col-md-12">
                      <span style="padding-top: 16px; display: block"
                        >Шилжүүлэх данс:
                      </span>
                      <select
                        v-model="selectedAccount"
                        @change="selectAccount()"
                        style="width: 100%"
                        class="form-control"
                      >
                        <option
                          v-for="account in this.accounts"
                          v-bind:key="account.Name"
                          v-bind:value="account"
                        >
                          {{ account.Name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <p style="float: left; width: 100%">
                    БОЛОМЖИТ ҮЛДЭГДЭЛ:
                    <b style="float: right; margin-top: -4px">
                      {{ this.balanceAmountStr }} ₮</b
                    >
                  </p>

                  <span>Хүлээн авагч:</span>
                  <div class="btnstyle">
                    <input
                      type="text"
                      class="form-control"
                      v-model="cardId"
                      placeholder="Карт / утасны дугаар"
                      @change="getCustomerInfo"
                      autofocus
                      required
                    />
                  </div>
                  <div style="margin-top: 10px" class="btnstyle">
                    <input
                      type="text"
                      class="form-control"
                      v-model="userName"
                      placeholder="Хүлээн авагчийн мэдээлэл"
                      readonly
                    />
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <span style="padding-top: 16px; display: block"
                        >Шилжүүлэх дүн:
                      </span>
                    </div>
                    <div class="col-md-6 text-right">
                      <span style="padding-top: 16px; display: block"
                        >{{ this.getAmountFormat() }} ₮</span
                      >
                    </div>
                  </div>
                  <b-form @submit.prevent="onSubmit">
                    <div class="btnstyle">
                      <input
                        type="number"
                        id="transactionAmount"
                        class="form-control text-right"
                        v-model="amount"
                        placeholder="Шилжүүлэх дүн"
                        required
                      />
                    </div>
                    <div style="margin-top: 10px" class="btnstyle">
                      <input
                        type="text"
                        class="form-control"
                        v-model="invDescription"
                        placeholder="Гүйлгээний утга"
                      />
                    </div>
                    <div class="form-item marginTop10 btnstyle">
                      <input
                        type="submit"
                        class="btn login-btn"
                        value="Шилжүүлэх"
                      />
                      <p @click="showHelpDlg">
                        Бонус шилжүүлэх заавар
                        <img src="@/assets/icon/right-arrow.png" alt="" />
                      </p>
                    </div>
                    <div class="form-item form-error-out" v-if="error">
                      <div class="form-error">
                        <div class="error-icon">
                          <img src="@/assets/icon/error.png" alt="" />
                        </div>
                        <div class="error-message">
                          <p v-html="errorMessage"></p>
                        </div>
                      </div>
                    </div>
                  </b-form>
                </div>
              </div>
              <div class="col-md-6 pdd-left phone-size">
                <div class="chartBackground">
                  <BonusChart :checked="checked" />
                </div>
              </div>
              <div class="col-md-3 pdd-left3">
                <UsedBonus />
                <ItemCategory />
              </div>
            </div>
          </div>
        </div>
      </div>
      <transition name="fade">
        <Success
          :sentEmail="sentEmail"
          :lottery="lottery"
          :qrData="qrData"
          :feeAmount="feeAmount"
          :email="email"
          :billId="billId"
          :cardId="cardUser"
          :amountStr="amountStr"
          :receiver="userName"
          :hideBarimt="hideBarimt"
          v-if="successModal"
          @hideSuccessMessage="hideSuccessMessage"
        ></Success>
      </transition>
      <transition name="fade">
        <Error
          :errorMessage="errorMessage"
          v-if="errorModal"
          @hideErrorMessage="hideErrorMessage"
        ></Error>
      </transition>
      <transition name="fade">
        <Help :message="message" v-if="showHelp" @hideHelp="hideHelp"></Help>
      </transition>
      <transition name="fade">
        <Transfer
          :cardId="cardId"
          :userName="userName"
          :amount="amountStr"
          :commission="commission"
          :invDescription="invDescription"
          :pinCode.sync="pinCode"
          v-if="showTransfer"
          @hideTransferModal="hideTransferModal"
          @bonusTransfer="bonusTransfer"
        ></Transfer>
      </transition>
      <transition name="fade">
        <confirmInfo
          v-if="showInfo"
          @hideInfoModal="hideInfoModal"
          @showSuccessMessage="showSuccessMessage"
        ></confirmInfo>
      </transition>
      <transition name="fade">
        <bonusChangeInfo
          v-if="showBonusChangeInfo"
          @hideBonusChangeModal="hideBonusChangeModal"
          @showSuccessMessage="showSuccessMessage"
        ></bonusChangeInfo>
      </transition>
      <transition name="fade">
        <showMessage
          :message="message"
          v-if="showMessage"
          @hideShowSuccessMessage="hideShowSuccessMessage"
        ></showMessage>
      </transition>
      <transition name="fade">
        <EbarimtInfo
          v-if="showEbarimtInfo"
          v-bind:ebarimtInfo="ebarimtInfo"
          :user="user"
          @hideEbarimtInfo="hideEbarimtInfo"
          @showSuccessMessage="showSuccessMessage"
        ></EbarimtInfo>
      </transition>
      <!-- <transition name="fade">
        <confirmOverlap
          v-if="showOverlap"
          @hideShowSuccessMessage="hideShowSuccessMessage"
          @onChooseOverlap="onChooseOverlap"
        ></confirmOverlap>
      </transition> -->
    </section>
  </div>
</template>

<script>
import Dashboard from "@/views/layout/Dashboard";
import Success from "@/views/plugin/successTransfer";
import Error from "@/views/plugin/error";
import showMessage from "@/views/plugin/successMessage";

import Transfer from "@/views/plugin/transfer";
import confirmInfo from "@/views/plugin/confirmInfo";
import Help from "@/views/plugin/help";
import bonusChangeInfo from "@/views/plugin/bonusChangeInfo";

import EbarimtInfo from "@/views/plugin/ebarimtInfo";

import NextPercentAmount from "./NextPercentAmount";
import ItemCategory from "./ItemCategory";
import BonusChart from "./BonusChart";
import EventBus from "../../EventBus";
import confirmOverlap from "@/views/plugin/confirmOverlap";
import UsedBonus from "./UsedBonus.vue";

export default {
  mounted() {
    this.findAccounts();
    this.confirmInfo();
  },
  data() {
    return {
      beginDate: "",
      endDate: "",
      cardId: "",
      cardUser: "",
      userName: "",
      error: false,
      errorMessage: "",
      amount: "",
      amountStr: "",
      invDescription: "",
      successModal: false,
      errorModal: false,
      showTransfer: false,
      commission: 0,
      isSelected: false,
      balanceAmount: 0,
      balanceAmountStr: "",
      checked: true,
      showHelp: false,
      showInfo: false,
      showBonusChangeInfo: false,
      showEbarimtInfo: false,
      statusCodeEbarimt: 0,
      resultDataEbarimtMsg: "",
      resultDataEbarimt: [],
      statusCodeEmail: 0,
      resultDataEmail: "",
      showMessage: false,
      showOverlap: false,
      message: "",
      type: "All",
      isMobile: false,
      ebarimtInfo: {},
      user: {},
      bonus: false,
      accounts: [],
      selectedAccount: {},
      billId: "",
      feeAmount: 0,
      lottery: "",
      qrData: "",
      sentEmail: 0,
      email: "",
      status: 0,
      hideBarimt: false,
      giftcardId: 0,
      pinCode: "",
    };
  },

  methods: {
    selectAccount() {
      if (this.selectedAccount) {
        let balanceAmountStr = new Intl.NumberFormat().format(
          Math.round(this.selectedAccount.Balance / 1.1)
        );
        let balanceAmount = Math.round(this.selectedAccount.Balance / 1.1);

        this.balanceAmount = balanceAmount;
        this.balanceAmountStr = balanceAmountStr;

        if (balanceAmount < 1000) {
          this.balanceAmount = 0;
          this.balanceAmountStr = "0";
        }
      } else {
        this.balanceAmount = 0;
        this.balanceAmountStr = "0";
      }
    },
    showHelpDlg() {
      this.showHelp = true;
    },
    getAmountFormat() {
      return new Intl.NumberFormat().format(this.amount);
    },
    getCustomerInfo() {
      this.$loading(true);
      var cardNumberPhone = this.cardId;
      var isnum = /^\d+$/.test(cardNumberPhone);
      let searchType = this.type;
      if (isnum && cardNumberPhone.length > 0) {
        var tokenId = localStorage.getItem("authToken");
        var user = this.$auth.getMe();
        if (tokenId == null || user == null) {
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        }
        var cardHolderInfId = user.cardHolderInfId;
        if (cardHolderInfId === cardNumberPhone) {
          this.errorModal = true;
          this.errorMessage = "Өөрлүүгээ бонус шилжүүлэх боломжгүй.";
          this.$loading(false);
          this.cardId = "";
          this.userName = "";
          return;
        }
        this.$auth.removeCustomerInfo();
        this.error = false;
        this.$bonusApi
          // .post(`card/customer/info`, {
          .post(`bonus-card/customer-info`, {
            // tokenId,
            cardNumberPhone,
            cardHolderInfId,
            searchType,
          })
          .then((response) => {
            var data = response.data;
            if (response.data.status === 0) {
              var cardHolderInfId = user.cardHolderInfId;
              if (cardHolderInfId == data.cardHolderInfId) {
                this.errorModal = true;
                this.errorMessage = "Өөрлүүгээ бонус шилжүүлэх боломжгүй.";
                this.$loading(false);
                this.cardId = "";
                this.userName = "";
                this.isSelected = false;
              } else {
                this.userName = data.firstName + " " + data.lastName;
                this.$auth.setCustomerInfo(data);
                this.isSelected = true;
                this.invDescription = "";
                document.getElementById("transactionAmount").focus();
              }
            } else if (response.data.status === 1) {
              this.showOverlap = true;
              return;
            } else {
              this.errorModal = true;
              this.errorMessage = data.message;
              this.cardId = "";
              this.userName = "";
              this.isSelected = false;
            }
          })
          .catch((error) => {
            this.errorModal = true;
            if (error.status == 404) {
              this.errorMessage = "Хэрэглэгч олдсонгүй!";
              return;
            }
            this.errorMessage = error.response.data.message;
            this.isSelected = false;
          });
      } else {
        this.errorModal = true;
        this.errorMessage = "Та зөвхөн тоо оруулна уу ?";
      }
      this.$loading(false);
    },
    onChooseOverlap(value) {
      this.type = value.SearchType;
      this.getCustomerInfo();
      this.showOverlap = false;
      this.type = "All";
    },
    onSubmit() {
      this.errorModal = false;
      this.errorModal = false;
      if (!this.isSelected) {
        this.errorModal = true;
        this.errorMessage = "Бонус шилжүүлэх хэрэглэгч заавал сонгоно уу !";
      } else if (this.amount < 1000) {
        this.errorModal = true;
        this.errorMessage = "1000 -аас бага бонус шилжүүлэх боломжгүй !";
      } else if (this.amount > this.balanceAmount) {
        this.errorModal = true;
        this.errorMessage = "Таны үлдэгдэл бонус оноо хүрэлцэхгүй байна !";
      } else if (JSON.stringify(this.selectedAccount) === "{}") {
        this.errorModal = true;
        this.errorMessage = "Таны шилжүүлэх дансаа сонгоно уу !";
      } else {
        var customerInfo = this.$auth.getCustomerInfo();
        var cardInfo = this.$auth.getCardInfo();
        if (this.invDescription === "") {
          this.invDescription =
            cardInfo.firstName + " - с " + customerInfo.firstName + " - д";
        }
        this.amountStr = new Intl.NumberFormat().format(this.amount);
        this.commission = new Intl.NumberFormat().format(
          Math.round((this.amount * 10) / 100)
        );
        this.showTransfer = true;
      }
    },
    hideSuccessMessage() {
      this.successModal = false;
      this.showTransfer = false;
      this.cardId = "";
      this.userName = "";
      this.invDescription = "";
      this.amount = 0;
      setTimeout(() => {
        this.calcBalanceAmount();
        EventBus.$emit("refreshDashboard");
      }, 4000);
    },
    hideErrorMessage() {
      (this.errorMessage = ""), (this.errorModal = false);
    },
    hideTransferModal() {
      this.showTransfer = false;
    },
    showSuccessMessage(value) {
      this.showMessage = true;
      this.message = value;
    },
    hideShowSuccessMessage() {
      this.showMessage = false;
    },
    hideInfoModal() {
      this.showInfo = false;
    },
    hideEbarimtInfo() {
      this.showEbarimtInfo = false;
    },
    hideHelp() {
      this.showHelp = false;
    },
    mounted() {
      this.$bvModal.show("bv-modal-example");
    },
    hideBonusChangeModal() {
      this.showBonusChangeInfo = false;
    },
    bonusTransfer() {
      console.log("bonus transfer works");
      var tokenId = localStorage.getItem("authToken");
      var user = this.$auth.getMe();
      if (tokenId == null || user == null) {
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      var cardInfo = this.$auth.getCardInfo();
      var cardHolderInfIDFrom = this.selectedAccount.pkey;
      var customerInfo = this.$auth.getCustomerInfo();
      var cardHolderInfIDTo = customerInfo.cardHolderInfId;
      var amount = this.amount;
      var cardPercent = cardInfo.cardPercent;
      var dstCardPercent = customerInfo.cardPercent;
      var invDescription = this.invDescription;
      var pinCode = this.pinCode;

      this.cardUser = cardInfo.firstName;
      if (invDescription === "")
        invDescription =
          cardInfo.firstName + " - ээс " + customerInfo.firstName + " - рүү";
      var customerName = cardInfo.firstName;
      this.$insProgress.start();
      if (this.giftcardId === cardHolderInfIDFrom) {
        this.hideBarimt = true;
      }
      var body = {
        amount,
        pinCode,
        token: tokenId,
        systemId: "web",
        userId: customerName,
        cardHolderDestKey: cardHolderInfIDTo,
        transactionDescription: invDescription,
        cardHolderSourceKey: cardHolderInfIDFrom,
      };
      this.$bonusApi
        .post("bonus/transfer", body, {
          headers: {
            Authorization: `${tokenId}`,
            "Accept-Language": "en-US",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          var data = response.data;
          if (data.status === 1) {
            this.successModal = true;
            //ebarimt
            this.statusCodeEbarimt = data.statusCodeEbarimt;
            this.statusCodeEmail = data.statusCodeEmail;

            this.qrData = data.qrData;
            this.lottery = data.lottery;
            this.feeAmount = data.feeAmount;
            this.sentEmail = data.sentEmail;
            this.email = data.email;
            this.errorMessage = data.errorMessage;
            this.status = data.status;
            this.billId = data.billId;

            // if (data.statusCodeEbarimt === 1) {
            //   this.resultDataEbarimt = JSON.parse(data.resultDataEbarimt);
            // } else {
            //   this.resultDataEbarimt = data.resultDataEbarimt;
            //   this.resultDataEbarimtMsg =
            //     "НӨАТУС-тэй холбогдож чадсангүй. Таны И-баримт 72 цагийн дотор бүртгэлтэй имэйл рүү тань нөхөж илгээгдэнэ. Хэрвээ илгээгдээгүй бол та гүйлгээний дэлгэрэнгүй хэсгээс имэйлээр авах дээр дарж ибаримтаа авна уу..";
            // }

            // this.resultDataEmail = data.resultDataEmail;
            //ebarimt
            this.$insProgress.finish();
          } else {
            this.hideBarimt = false;
            this.showTransfer = false;
            this.errorModal = true;
            this.errorMessage = data.errorMessage;
            this.$insProgress.finish();
          }
        })
        .catch((error) => {
          this.errorModal = true;
          this.errorMessage = error;
        });
    },
    findAccounts() {
      var tokenId = localStorage.getItem("authToken");
      var user = this.$auth.getMe();
      var cardHolderInfId = user.cardHolderInfId;
      if (tokenId == null || user == null) {
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
        return;
      }
      this.$loading(true);
      this.$bonusApi
        // this.$axiosApi
        .post(
          `bonus-card/accounts`,
          // `card/bonus/accounts`,
          { cardHolderInfId },
          // { tokenId },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          this.accounts = response.data.accounts;
          if (response.data.accounts.length == 1) {
            this.selectedAccount = response.data.accounts[0];

            let balanceAmountStr = new Intl.NumberFormat().format(
              Math.round(this.selectedAccount.Balance / 1.1)
            );
            let balanceAmount = Math.round(this.selectedAccount.Balance / 1.1);

            this.balanceAmount = balanceAmount;
            this.balanceAmountStr = balanceAmountStr;

            if (balanceAmount < 1000) {
              this.balanceAmount = 0;
              this.balanceAmountStr = "0";
            }
          }
          this.giftcardId = response.data.accounts.find(
            (a) => a.walletTypeKey === 1100
          );
        })
        .catch((error) => {
          console.log(error, "error account");
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
      this.$loading(false);
    },
    calcBalanceAmount() {
      var tokenId = localStorage.getItem("authToken");
      var user = this.$auth.getMe();
      if (tokenId == null || user == null) {
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
        return;
      }
      this.$loading(true);
      this.$bonusApi
        // this.$axiosApi
        .post(
          // `card/info`,
          `bonus-card/info/token`,
          { tokenId },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var results = response.data;
          if (results.status === 0) {
            this.balanceAmountStr = new Intl.NumberFormat().format(
              Math.round(results.bonusBalance / 1.1)
            );
            this.balanceAmount = Math.round(results.bonusBalance / 1.1);
            if (this.balanceAmount < 1000) {
              this.balanceAmount = 0;
              this.balanceAmountStr = "0";
            }
          } else {
            this.balanceAmount = 0;
            this.balanceAmountStr = "0";
          }
        })
        .catch((error) => {
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
      this.$loading(false);
    },
    confirmInfo() {
      var tokenId = localStorage.getItem("authToken");
      var user = this.$auth.getMe();

      if (tokenId == null || user == null) {
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      var cardInfo = this.$auth.getCardInfo();

      this.showInfo =
        cardInfo.IsConfirmInformation == null ||
        cardInfo.IsConfirmInformation == 0 ||
        cardInfo.isPosCardConfirm == 0 ||
        cardInfo.isConfirmAgreement == 0 ||
        cardInfo.isConfirmAgreement == null
          ? true
          : false;
      this.showBonusChangeInfo = cardInfo.IsConfirmInformation == 1;
      this.showEbarimtInfo = cardInfo.IsEbarimt == 0 ? true : false;
      this.user = this.$auth.getCardInfo();
    },

    cardInfoList() {
      var cardHolderInfo = this.$auth.getCardInfo();
      if (cardHolderInfo.CartType === "Bonus") {
        this.bonus = true;
      }
    },
    //hide menu mobile when page loaded
    hideMenu() {
      EventBus.$emit("MOBILE_MENU_HIDE");
    },
  },

  created() {
    this.hideMenu();
    this.cardInfoList();
  },
  beforeMount() {
    this.ebarimtInfo = this.$auth.getEbarimtInfo();
  },
  components: {
    Dashboard,
    confirmInfo,
    bonusChangeInfo,
    Success,
    Error,
    Transfer,
    NextPercentAmount,
    ItemCategory,
    BonusChart,
    Help,
    showMessage,
    confirmOverlap,
    EbarimtInfo,
    UsedBonus,
  },
};
</script>

<style>
.marinTop {
  margin-top: 10%;
}
.prog {
  background: #1660ab;
  width: 100%;
  height: 10px;
  border-radius: 6px;
  position: relative;
}
.prog span {
  content: "";
  height: 10px;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  background: #f7941d;
  position: absolute;
}
.prowidth10 {
  width: 10%;
}
.prowidth20 {
  width: 20%;
}
.prowidth30 {
  width: 30%;
}
.prowidth40 {
  width: 40%;
}
.prowidth50 {
  width: 50%;
}
.prowidth60 {
  width: 60%;
}
.prowidth70 {
  width: 70%;
}
.prowidth80 {
  width: 80%;
}
.prowidth90 {
  width: 90%;
}
.prowidth100 {
  width: 100%;
}
.box-1 {
  padding: 10px 10px 20px 10px;
  margin: 0;
  background: #fff;
  margin-bottom: 10px;
}
.box-1 p {
  padding: 0;
  margin: 0;
  font-size: 14px;
}
.imgBox {
  padding: 0;
  margin: 0;
}
.img-info {
  padding: 0;
  margin: 0;
}

.img-info p {
  padding: 0;
  margin: 0;
  font-size: 12px;
  color: #939393;
}
.img-info span {
  color: #939393;
  font-size: 12px;
}
.img-info b {
  color: #1660ab;
  font-size: 16px;
}
.box-2 {
  padding: 20px 20px;
  padding-top: 8px;
  margin: 0;
  background: #fff;
  margin-bottom: 10px;
}
.box-2 b {
  font-size: 14px;
  color: #1660ab;
}
.box-2 p {
  font-size: 10px;
  color: #939393;
  padding: 5px 0;
  margin: 0;
  cursor: pointer;
}
.box-2 span {
  color: #1660ab;
  margin: 0;
  padding: 0;
  font-size: 12px;
  font-weight: bold;
}
.box-icon {
  margin: 0;
}
.box-icon img {
  width: 24px;
}
.box3 {
  margin: 0;
  padding: 10px;
  background: #fff;
  border-bottom: 1px solid #e4e4e4;
  position: relative;
}
.box3 p {
  margin: 0;
  padding: 0;
  font-size: 12px;
  color: #939393;
  display: inline-block;
}
.box3 h2 {
  display: inline-block;
  text-align: right;
  margin: 0;
  padding: 0;
  font-size: 12px;
  padding-left: 10px;
}
.box3 .ka-progress {
  width: 0;
  height: 2px;
  margin: 0;
  margin-top: 3px;
  background: #1660ab;
}
.box4 {
  right: 15px;
  top: 10px;
  position: absolute;
}
.pie-title-center {
  display: inline-block;
  position: relative;
  text-align: center;
}

.pie-value {
  display: block;
  position: absolute;
  font-size: 14px;
  height: 40px;
  top: 50%;
  left: 0;
  right: 0;
  margin-top: -20px;
  line-height: 40px;
}

.box-scroll {
  height: 440px;
  overflow: hidden;
}
.box-scroll:hover {
  overflow-y: scroll;
}

/* Progress bar rotation position */
.ka-progress.p0 {
  display: none;
}
.ka-progress.p1 {
  width: 1%;
}
.ka-progress.p2 {
  width: 2%;
}
.ka-progress.p3 {
  width: 3%;
}
.ka-progress.p4 {
  width: 4%;
}
.ka-progress.p5 {
  width: 5%;
}
.ka-progress.p6 {
  width: 6%;
}
.ka-progress.p7 {
  width: 7%;
}
.ka-progress.p8 {
  width: 8%;
}
.ka-progress.p9 {
  width: 9%;
}
.ka-progress.p10 {
  width: 10%;
}
.ka-progress.p11 {
  width: 11%;
}
.ka-progress.p12 {
  width: 12%;
}
.ka-progress.p13 {
  width: 13%;
}
.ka-progress.p14 {
  width: 14%;
}
.ka-progress.p15 {
  width: 15%;
}
.ka-progress.p16 {
  width: 16%;
}
.ka-progress.p17 {
  width: 17%;
}
.ka-progress.p18 {
  width: 18%;
}
.ka-progress.p19 {
  width: 19%;
}
.ka-progress.p20 {
  width: 20%;
}
.ka-progress.p21 {
  width: 21%;
}
.ka-progress.p22 {
  width: 22%;
}
.ka-progress.p23 {
  width: 23%;
}
.ka-progress.p24 {
  width: 24%;
}
.ka-progress.p25 {
  width: 25%;
}
.ka-progress.p26 {
  width: 26%;
}
.ka-progress.p27 {
  width: 27%;
}
.ka-progress.p28 {
  width: 28%;
}
.ka-progress.p29 {
  width: 29%;
}
.ka-progress.p30 {
  width: 30%;
}
.ka-progress.p31 {
  width: 31%;
}
.ka-progress.p32 {
  width: 32%;
}
.ka-progress.p33 {
  width: 33%;
}
.ka-progress.p34 {
  width: 34%;
}
.ka-progress.p35 {
  width: 35%;
}
.ka-progress.p36 {
  width: 36%;
}
.ka-progress.p37 {
  width: 37%;
}
.ka-progress.p38 {
  width: 38%;
}
.ka-progress.p39 {
  width: 39%;
}
.ka-progress.p40 {
  width: 40%;
}
.ka-progress.p41 {
  width: 41%;
}
.ka-progress.p42 {
  width: 42%;
}
.ka-progress.p43 {
  width: 43%;
}
.ka-progress.p44 {
  width: 44%;
}
.ka-progress.p45 {
  width: 45%;
}
.ka-progress.p46 {
  width: 46%;
}
.ka-progress.p47 {
  width: 47%;
}
.ka-progress.p48 {
  width: 48%;
}
.ka-progress.p49 {
  width: 49%;
}
.ka-progress.p50 {
  width: 50%;
}
.ka-progress.p51 {
  width: 51%;
}
.ka-progress.p52 {
  width: 52%;
}
.ka-progress.p53 {
  width: 53%;
}
.ka-progress.p54 {
  width: 54%;
}
.ka-progress.p55 {
  width: 55%;
}
.ka-progress.p56 {
  width: 56%;
}
.ka-progress.p57 {
  width: 57%;
}
.ka-progress.p58 {
  width: 58%;
}
.ka-progress.p59 {
  width: 59%;
}
.ka-progress.p60 {
  width: 60%;
}
.ka-progress.p61 {
  width: 61%;
}
.ka-progress.p62 {
  width: 62%;
}
.ka-progress.p63 {
  width: 63%;
}
.ka-progress.p64 {
  width: 64%;
}
.ka-progress.p65 {
  width: 65%;
}
.ka-progress.p66 {
  width: 66%;
}
.ka-progress.p67 {
  width: 67%;
}
.ka-progress.p68 {
  width: 68%;
}
.ka-progress.p69 {
  width: 69%;
}
.ka-progress.p70 {
  width: 70%;
}
.ka-progress.p71 {
  width: 71%;
}
.ka-progress.p72 {
  width: 72%;
}
.ka-progress.p73 {
  width: 73%;
}
.ka-progress.p74 {
  width: 74%;
}
.ka-progress.p75 {
  width: 75%;
}
.ka-progress.p76 {
  width: 76%;
}
.ka-progress.p77 {
  width: 77%;
}
.ka-progress.p78 {
  width: 78%;
}
.ka-progress.p79 {
  width: 79%;
}
.ka-progress.p80 {
  width: 80%;
}
.ka-progress.p81 {
  width: 81%;
}
.ka-progress.p82 {
  width: 82%;
}
.ka-progress.p83 {
  width: 83%;
}
.ka-progress.p84 {
  width: 84%;
}
.ka-progress.p85 {
  width: 85%;
}
.ka-progress.p85 {
  width: 85%;
}
.ka-progress.p86 {
  width: 86%;
}
.ka-progress.p87 {
  width: 87%;
}
.ka-progress.p88 {
  width: 88%;
}
.ka-progress.p89 {
  width: 89%;
}
.ka-progress.p90 {
  width: 90%;
}
.ka-progress.p91 {
  width: 91%;
}
.ka-progress.p92 {
  width: 92%;
}
.ka-progress.p93 {
  width: 93%;
}
.ka-progress.p94 {
  width: 94%;
}
.ka-progress.p95 {
  width: 95%;
}
.ka-progress.p96 {
  width: 96%;
}
.ka-progress.p97 {
  width: 97%;
}
.ka-progress.p98 {
  width: 98%;
}
.ka-progress.p99 {
  width: 99%;
}
.ka-progress.p100 {
  width: 100%;
}

.chartBackground {
  background: #fff;
  margin: 0 10px;
  padding: 0;
}

.bgImage1 {
  background-image: url("../../assets/icon/active-icon-black.png") !important;
}
.box-title01 {
  margin: 0;
  padding: 0;
  padding-bottom: 10px;
}
.box-title01 p {
  font-size: 16px;
  color: #1660ab;
  font-weight: bold;
  text-align: center;
  border-bottom: 1px solid #bdbdbd;
  padding-bottom: 10px;
  padding-top: 10px;
  position: relative;
}
.box-title01 p:before {
  content: "";
  bottom: -1px;
  right: 0;
  width: 50px;
  height: 2px;
  background: #1660ab;
  position: absolute;
}
.box-title01 img {
  padding-left: 20px;
}
.col-md-6.pdd-left {
  padding-left: 0;
  padding-right: 0;
}
.col-md-3.pdd-left2 {
  padding-right: 10px;
}
.col-md-3.pdd-left3 {
  padding-left: 10px;
}
.btnstyle p {
  margin: 0;
  font-size: 14px;
  color: #1660ab;
  text-align: center;
  margin-top: 10px;
}
.btnstyle img {
  padding-left: 6px;
  width: 22px;
}
.bgHeader .card-header {
  background: #007bff;
  color: #fff;
}

/* .form-control {
  padding: 6px 20px;
  height: 30px !important;
}
.form-control.heightAuto {
  height: auto;
  padding: 3px 10px;
} */
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12 {
  padding: 0 15px;
}
@media screen and (max-width: 768px) {
  .box-2 {
    height: auto;
    padding: 10px;
  }
  .phone-size {
    width: 100%;
  }
  .box-scroll {
    height: 100%;
  }
  .form-item.btnstyle input {
    width: 100%;
  }
  .box-title01 p {
    font-size: 13px;
  }
  .box-title01 img {
    height: 10px;
    padding-left: 5px;
  }
  .btnstyle input {
    padding: 10px 5px;
  }
  .btnstyle input::placeholder {
    font-size: 9px;
    padding: 10px 5px;
  }
}
</style>
